export class CourrierLinked {
  description: string;
  id: number;
}
